(function () {

   var cartPage = function () {
            var today = new Date();
            var tomorrow = kendo.date.nextDay(today);
            var cutoffHour = 19;
            var specialHour = null;
            var earlyCutOffHour = 17;
            var earlyCutOffDate = null; // 28-01-2025
            var daysOfWeek = []; // 0 for Sunday
            var offDays = (function () {
           var dates = [
               new Date(2025, 0, 1).getTime(),
               new Date(2025, 0, 28).getTime(),
               new Date(2025, 0, 29).getTime(),
               new Date(2025, 0, 30).getTime(), 
               new Date(2025, 1, 14).getTime(),
               new Date(2025, 2, 31).getTime(),
               new Date(2025, 3, 1).getTime()
             ];
              // no orders for 23rd May after 4pm 22nd May
                /*if (today > new Date(2020, 4, 22, 16)) {
                  dates.push(new Date(2020,4,23).getTime());
                }*/
                return dates;
            })();

            var canDeliver = function (date) {
                if (!date) {
                    return false;
                }
                  if (daysOfWeek.indexOf(date.getDay()) > -1){
                    return false;
                  }
                  if (offDays.indexOf(new Date(date).setHours(0,0,0,0)) > -1) {
                    return false;
                  }
                  if (kendo.date.isToday(date) && date.getHours() >= cutoffHour) {
                    return false;
                  }
                return true;
            }



            // find minimum available date

            var maxDate = $('#maxDate');
            var today = new Date();

            if (maxDate.val()) {
                console.log('maxDate', maxDate.val());
                var maximumDate = kendo.parseDate(maxDate.val(), 'dd-MM-yyyy');
                console.log('maximumDate', maximumDate);
            } else {
                var maximumDate = new Date(today.getFullYear(), today.getMonth() + 9, today.getDate());
            }


            var minDate = $('#leadTime').val();
            var minHour = $('#lead_time_hour').val();
            var startSale = $('#startSale');
            var startSaleVal = startSale.val();

            //check if there's a pre-order date
            //if yes check if today > pre-order date
              if (startSale.val()) {
                console.log('startsale', startSale.val());
                var startDate = kendo.parseDate(startSale.val(), 'dd-MM-yyyy');
              } else if (startSaleVal.length < 1 && minDate > 0) {
                console.log(minDate);
                var leadTimeDate = today.getDate() + parseInt(minDate);
                var minimumDate = new Date(today.getFullYear(), today.getMonth(), leadTimeDate)
                console.log('preorder-nil leadtime-yes', minimumDate);
              } else if (startSaleVal.length < 1 && minDate.length < 1) {
                var minimumDate = new Date(today);
              }

              if (today < startDate === true) {
                //if today > preorderDate, set minimumDate to today
                var minimumDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                console.log('today<startDate', minimumDate);
              } else if (today >= startDate && minDate > 1) {
                var startSaleDate = new Date();
                console.log(minDate);
                var leadTimeDate = startSaleDate.getDate() + parseInt(minDate);
                var minimumDate = new Date(startSaleDate.getFullYear(), startSaleDate.getMonth(), leadTimeDate)
                console.log('today > startDate & leadTime', minimumDate);
              } else if (today >= startDate && minDate.length < 1) {
                var minimumDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                console.log('today >= today, minDate nil', minimumDate);
              } else if (today >= startDate && minDate == 1) {
                var startSaleDate = new Date();
                console.log(minDate);
                var leadTimeDate = startSaleDate.getDate() + parseInt(minDate);
                var minimumDate = new Date(startSaleDate.getFullYear(), startSaleDate.getMonth(), leadTimeDate)
                console.log('today > startDate & leadTime', minimumDate);
              }
              

              if (minimumDate.getDate() === tomorrow.getDate() && today.getHours() > cutoffHour) {
                minimumDate.setDate(minimumDate.getDate() + 1);
              };


              while (!canDeliver(minimumDate)) {
                minimumDate.setDate(minimumDate.getDate() + 1);
             }
                        
              

            var deliveryDateField = $('#delivery-date-field');
            var calendarValue;
            if (deliveryDateField.val()) {
                console.log('deliveryDateField', deliveryDateField.val());
                calendarValue = kendo.parseDate(deliveryDateField.val(), 'dd-MM-yyyy');
                console.log('deliveryDateField parsed', calendarValue);
                if (calendarValue < minimumDate) {
                    console.log('previous selected date is in the past, resetting')
                    calendarValue = minimumDate;
                } else if (!canDeliver(calendarValue)) {
                    calendarValue = minimumDate;
                }
            } else {
                calendarValue = minimumDate;
            }

            deliveryDateField.val(kendo.toString(calendarValue, 'dd-MM-yyyy'));
            console.log('deliveryDateField', deliveryDateField.val());

            var timeWidgetEl = $('#delivery-time');
            var deliveryTimeField = $('#delivery-time-field');
            timeWidgetEl.on('change', function () {
               $('#validation-message').hide();
                  timeWidgetEl.hasClass("error") ? timeWidgetEl.removeClass("error") : false;         
              deliveryTimeField.val(timeWidgetEl.val());
            });
        
            var timeWidgetOptions = $('option', timeWidgetEl).slice(1);
           var updateTimeOptions = function() {
              var selectedDate = dateWidget.value();
              var dateSelect = kendo.parseDate(selectedDate,"dd-MM-yyyy");
               console.log('updateTimeOptions', selectedDate);
               console.log('dateSelect',dateSelect)
               var time = new Date().getHours(); 
               timeWidgetEl.val('').trigger('change');


               // check if selectedDate == earlyCutOffDate

             if(dateSelect.getDate() == earlyCutOffDate?earlyCutOffDate.getDate():false){
              console.log('date selected == cutoffdate')
              timeWidgetOptions.each(function () {
                if ($(this).data('cutoff') < earlyCutOffHour) {
                  $(this).prop('disabled', 'disabled').css('display','none')
                  if (time < $(this).data('cutoff')) {
                    $(this).prop('disabled', 'disabled').css('display','none')
                  }
              } else  {
                $(this).prop('disabled','').css('display','block');
              }
             });
            } else {

        
              if (!selectedDate) {
                timeWidgetOptions.each(function () {
                  if ($(this).data('cutoff') != 21){
                    $(this).prop('disabled', '')
                  } else {
                    $(this).prop('disabled','disabled');
                };
                })
              }
              else if (kendo.date.isToday(selectedDate) && time == specialHour) {
                timeWidgetOptions.each(function () {
                   if ($(this).data('cutoff') != 21) {
                     $(this).prop('disabled', 'disabled').css('display','none')
                   } else {
                     $(this).css('display','block')
                     var option = $(this);
                     option.prop('disabled', time < option.data('cutoff') ? '' : 'disabled');
                     option.css('color', time < option.data('cutoff') ? 'inherit' : 'lightgray')
                   }
                }) 
              } else if (kendo.date.isToday(selectedDate) && time != specialHour) {
                    if (minHour != ''){ 
                      minHour = parseInt(minHour);
                      time = time + minHour;
                    }
                
                    timeWidgetOptions.each(function() {
                      if ($(this).data('cutoff') == 21) {
                        $(this).prop('disabled', 'disabled').css('display','none')
                      } else {
                        $(this).css('display', 'block')
                        var option = $(this);
                        option.prop('disabled', time < option.data('cutoff') ? '' : 'disabled');
                    }
                })    
              } 
             else {
                  // enable all options
                timeWidgetOptions.each(function() {
                 if ($(this).data('cutoff') == 21) {
                        $(this).prop('disabled', 'disabled').css('display','none')
                      } else {
                        $(this).prop('disabled','').css('display','block');
                      }
                });
              }
              

                         
              timeWidgetEl.val('').trigger('change');
            }
          }
          
           
              var dateWidgetEl = $('#delivery-date');
            dateWidgetEl.kendoDatePicker({
                adaptiveMode: "auto",
                fillMode: "solid",
                size : "large",
                componentType: "modern",
                value: calendarValue,
                format: "dd-MM-yyyy",
                min: minimumDate,
                max: maximumDate,
                change: function onCalendarChange() {
                    deliveryDateField.val(kendo.toString(this.value(), 'dd-MM-yyyy'));
                    updateTimeOptions();
                },
                dateInput: false,
                disableDates: function (date) {
                    return !canDeliver(date);
                }
            });
      dateWidgetEl.attr("readonly", true);
       //$(".k-icon").removeClass("k-i-calendar");
       //$(".k-icon").addClass('k-i-calendar-date');
       
     var dateWidget = dateWidgetEl.data('kendoDatePicker');
    //  maximumDate < today ? $('#delivery-date').data("kendoDatePicker").enable(false) : false

     updateTimeOptions();

     var validationMessage = $('#validation-message').hide();
     var message = $('#validation-message')
     
      if (minimumDate > maximumDate) {
      console.log('disable datepicker')
       dateWidget.enable('false');
       $('#addcart').attr('disabled', 'disabled')
     }

     

            $('.product-form__submit').on('click', function (e) {
                validationMessage.hide();
                // validate a date and time is selected
                var delDateVal = deliveryDateField.val();
                var delTimeVal = deliveryTimeField.val();
                if (!delDateVal || !delTimeVal) {
                  validationMessage.show();
                  e.preventDefault();
                  var time = document.getElementById('delivery-time')
                  time.classList.add("error");
                  time.scrollIntoView(false);
                  return;
                }


                // validate selected date and time is not in the past
                var selectedDate = kendo.parseDate(delDateVal, 'dd-MM-yyyy');
              var selectedTime = $(`#delivery-time option:contains(${delTimeVal})`).data('cutoff');
              var today = new Date();
              selectedDate.setHours(selectedTime);
              validateSelectedDate(selectedDate)

              function validateSelectedDate(selectedDate) {
                var dateWidgetEl = $('#delivery-date');
                var dateWidget = dateWidgetEl.data('kendoDatePicker');


                console.log(maximumDate)

                if (!maximumDate) {
                  return;
                }
                if (maximumDate > today && selectedDate < maximumDate) {
                  return;
                }
                if (maximumDate === today && selectedDate === today) {
                  return;
                }
                if (selectedDate < today || maximumDate < today) {
                  // $('delivery-date').data('kendoDatePicker').enable('false');
                }
              }

                function callError() {
                  alert("Please select delivery date and time again.");
                  validationMessage.show();
                  e.preventDefault();
                  location.reload();
                  return;
                }
            });
    }
    
    $(document).ready(function () {
        if ($('#delivery-date-time').length > 0) {
            cartPage();
        }
    })
})();